import {
    FaCheckCircle,
    FaMapMarkerAlt,
    FaTruck,
    FaCalendarAlt,
    FaHeart,
    FaChartLine,
    FaAward
} from 'react-icons/fa';

import YORK from '../../../../assets/profile2.jpg';
import YORK_WHITE from '../../../../assets/york-white.png';


function AboutPage() {
    const unidades = [
        {
            cidade: 'Teresina',
            estado: 'PI',
            tipo: 'Corporativo',
            descricao: 'Centro de gestão estratégica e suporte às operações da Distribuidora York.'
        },
        {
            cidade: 'Caxias',
            estado: 'MA',
            tipo: 'Distribuidor Autorizado (DA)',
            descricao: 'Responsável pelas operações de vendas e entregas na região.'
        },
        {
            cidade: 'Picos',
            estado: 'PI',
            tipo: 'Distribuidor Logístico (DL)',
            descricao: 'Operação logística responsável pelas entregas na região.'
        },
        {
            cidade: 'Floriano',
            estado: 'PI',
            tipo: 'Distribuidor Logístico (DL)',
            descricao: 'Operação logística responsável pelas entregas na região.'
        },
        {
            cidade: 'Piripiri',
            estado: 'PI',
            tipo: 'Distribuidor Logístico (DL)',
            descricao: 'Operação logística responsável pelas entregas na região.'
        }
    ];

    const valores = [
        {
            icon: <FaAward />,
            titulo: 'Qualidade',
            descricao:
                'Buscamos excelência em cada etapa da nossa operação, garantindo segurança, responsabilidade e qualidade em cada entrega.'
        },
        {
            icon: <FaChartLine />,
            titulo: 'Desempenho',
            descricao:
                'Trabalhamos com foco em eficiência e melhoria contínua para superar desafios e alcançar resultados cada vez melhores.'
        },
        {
            icon: <FaHeart />,
            titulo: 'Valorização das Pessoas',
            descricao:
                'Acreditamos que são as pessoas que constroem nossa história e tornam possível a evolução da nossa empresa.'
        }
    ];

    return (
        <main className="bg-white">
            {/* HERO */}
            <section className="relative overflow-hidden bg-gradient-to-br from-[#8f0d0f] via-[#D21214] to-[#e52b2d] text-white py-14">
                <div className="absolute inset-0 opacity-10">
                    <div className="absolute -top-32 -right-32 w-64 h-64 rounded-full border-[60px] border-white" />
                    <div className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full border-[80px] border-white z-[10]" />
                </div>

                <img
                    src={YORK_WHITE}
                    alt=""
                    aria-hidden="true"
                    className="
                        absolute
                        right-[1%]
                        top-1/2
                        -translate-y-1/2
                        w-[450px]
                        lg:w-[500px]
                        opacity-[0.12]
                        pointer-events-none
                        select-none
                        object-cover
                        py-40
                        z-[2]
                    "
                />

                <div className="container mx-auto px-4 py-24 md:py-32 relative z-10">
                    <div className="max-w-4xl">

                        <span className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 px-4 py-2 rounded-full text-sm font-semibold mb-6">
                            <FaCalendarAlt />
                            DESDE 1983
                        </span>

                        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight mb-6">
                            Uma história construída
                            <span className="block text-yellow-300">
                                ao longo de 42 anos
                            </span>
                        </h1>

                        <p className="text-lg md:text-xl text-red-50 max-w-3xl leading-relaxed">
                            Compromisso, excelência e dedicação fazem parte de uma
                            trajetória que começou em 1983 e continua sendo construída
                            todos os dias.
                        </p>
                    </div>
                </div>
            </section>

            {/* NOSSA HISTÓRIA */}
            <section className="py-20 md:py-28">
                <div className="container mx-auto px-4">

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

                        {/* Imagem / Card */}
                        <div className="relative">
                            <div className="absolute -inset-4 bg-red-100 rounded-3xl transform -rotate-3" />

                            <div className="relative bg-[#D21214] rounded-3xl p-8 md:p-12 text-white shadow-xl">
                                <div className="flex flex-col items-center text-center">

                                    <img
                                        src={YORK}
                                        alt="Distribuidora York"
                                        className="w-48 h-48 object-cover rounded-full border-8 border-white/20 shadow-lg mb-8"
                                    />

                                    <span className="text-red-100 text-sm font-semibold tracking-widest uppercase">
                                        Nossa trajetória
                                    </span>

                                    <h2 className="text-6xl md:text-7xl font-bold mt-2 text-gray-100">
                                        42
                                    </h2>

                                    <p className="text-2xl font-semibold text-red-100 leading-relaxed">
                                        anos de história
                                    </p>

                                    <div className="w-16 h-1 bg-yellow-300 rounded-full my-6" />

                                    <p className="text-red-100 leading-relaxed max-w-sm">
                                        Uma trajetória construída com trabalho,
                                        dedicação, evolução e compromisso com cada
                                        região onde atuamos.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Texto */}
                        <div>
                            <span className="text-red-600 font-bold text-sm tracking-widest uppercase">
                                Onde tudo começou
                            </span>

                            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mt-3 mb-8 leading-tight">
                                Uma história que começou em
                                <span className="text-red-600"> outubro de 1983</span>
                            </h2>

                            <div className="space-y-5 text-gray-600 text-lg leading-relaxed">
                                <p>
                                    A <strong className="text-gray-900">Distribuidora York</strong> foi
                                    fundada em outubro de 1983, tendo a família Aragão como
                                    sua controladora. Desde o início, sua trajetória tem sido
                                    marcada pelo compromisso com o desenvolvimento, pela
                                    busca da excelência e pela capacidade de superar os
                                    desafios de uma região de grande extensão e diversidade.
                                </p>

                                <p>
                                    Ao longo de mais de quatro décadas, a empresa cresceu,
                                    evoluiu e acompanhou as transformações do mercado.
                                    Sua operação foi se desenvolvendo e se adaptando às
                                    necessidades de cada região, sempre com o objetivo de
                                    realizar suas atividades com eficiência, qualidade e
                                    responsabilidade.
                                </p>

                                <p>
                                    Essa trajetória foi construída por gerações de
                                    colaboradores que, com dedicação e compromisso,
                                    contribuíram para transformar a Distribuidora York
                                    na empresa que é hoje.
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* LINHA DO TEMPO */}
            <section className="py-20 bg-gray-50">
                <div className="container mx-auto px-4">

                    <div className="text-center max-w-3xl mx-auto mb-16">
                        <span className="text-red-600 font-bold text-sm tracking-widest uppercase">
                            Nossa evolução
                        </span>

                        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mt-3 mb-5">
                            Mais de quatro décadas de história
                        </h2>

                        <p className="text-gray-600 text-lg">
                            Uma trajetória marcada pelo crescimento, pela transformação
                            e pela constante evolução das nossas operações.
                        </p>
                    </div>

                    <div className="max-w-5xl mx-auto">
                        <div className="relative">

                            {/* Linha */}
                            <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-1 bg-red-100 -translate-x-1/2" />

                            {/* 1983 */}
                            <TimelineItem
                                ano="1983"
                                titulo="O início da nossa história"
                                descricao="Em outubro de 1983, nasce a Distribuidora York, dando início a uma trajetória que seria construída com trabalho, compromisso e dedicação."
                                lado="left"
                            />

                            {/* Crescimento */}
                            <TimelineItem
                                ano="Crescimento"
                                titulo="Expansão das operações"
                                descricao="Ao longo dos anos, a empresa ampliou sua presença e sua capacidade operacional, enfrentando o desafio de atender uma extensa e diversificada área geográfica."
                                lado="right"
                            />

                            {/* Evolução */}
                            <TimelineItem
                                ano="Evolução"
                                titulo="Transformação e desenvolvimento"
                                descricao="Acompanhando as mudanças do mercado, a Distribuidora York investiu na evolução de seus processos, de suas pessoas e da sua estrutura operacional."
                                lado="left"
                            />

                            {/* Hoje */}
                            <TimelineItem
                                ano="Hoje"
                                titulo="Uma nova fase da nossa história"
                                descricao="Atualmente, atuamos como distribuidor logístico responsável pela entrega dos produtos Coca-Cola, com operações no Piauí e Maranhão."
                                lado="right"
                            />

                        </div>
                    </div>
                </div>
            </section>

            {/* OPERAÇÃO ATUAL */}
            <section className="py-20 md:py-28">
                <div className="container mx-auto px-4">

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

                        <div>
                            <span className="text-red-600 font-bold text-sm tracking-widest uppercase">
                                Quem somos hoje
                            </span>

                            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mt-3 mb-8 leading-tight">
                                Uma operação conectada pela
                                <span className="text-red-600"> excelência logística</span>
                            </h2>

                            <div className="space-y-5 text-gray-600 text-lg leading-relaxed">
                                <p>
                                    Hoje, somos um distribuidor logístico responsável pela
                                    entrega dos <strong className="text-gray-900">produtos Coca-Cola</strong>,
                                    atuando em uma região de grande extensão e diversidade.
                                </p>

                                <p>
                                    Nosso corporativo está localizado em
                                    <strong className="text-gray-900"> Teresina-PI</strong>,
                                    garantindo a gestão estratégica e o suporte necessário
                                    para o desenvolvimento das nossas operações.
                                </p>

                                <p>
                                    Em <strong className="text-gray-900">Caxias-MA</strong>,
                                    contamos com um Distribuidor Autorizado (DA), responsável
                                    pelas vendas e entregas da região. No Piauí, contamos com
                                    Distribuidores Logísticos (DL) em
                                    <strong className="text-gray-900"> Picos, Floriano e Piripiri</strong>,
                                    responsáveis pelas operações de entrega em suas regiões.
                                </p>
                            </div>
                        </div>

                        {/* Destaque */}
                        <div className="bg-gray-50 rounded-3xl p-8 md:p-12 border border-gray-100">
                            <div className="w-16 h-16 bg-red-600 rounded-2xl flex items-center justify-center text-white text-2xl mb-8">
                                <FaTruck />
                            </div>

                            <h3 className="text-3xl font-bold text-gray-900 mb-5">
                                Nosso propósito em movimento
                            </h3>

                            <p className="text-gray-600 text-lg leading-relaxed mb-8">
                                Mais do que transportar produtos, nossa operação conecta
                                marcas, clientes e consumidores. Todos os dias, nossas
                                equipes trabalham para garantir entregas realizadas com
                                segurança, eficiência e responsabilidade.
                            </p>

                            <div className="space-y-4">
                                <CheckItem text="Eficiência em nossas operações" />
                                <CheckItem text="Qualidade em cada entrega" />
                                <CheckItem text="Compromisso com clientes e parceiros" />
                                <CheckItem text="Evolução contínua dos nossos processos" />
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* PRESENÇA REGIONAL */}
            <section className="py-20 md:py-28 bg-gray-950 text-white">
                <div className="container mx-auto px-4">

                    <div className="text-center max-w-3xl mx-auto mb-16">
                        <span className="text-red-400 font-bold text-sm tracking-widest uppercase">
                            Nossa presença
                        </span>

                        <h2 className="text-3xl md:text-5xl font-bold mt-3 mb-5 text-gray-100">
                            Presentes no Piauí e Maranhão
                        </h2>

                        <p className="text-gray-400 text-lg">
                            Uma estrutura formada por operações que trabalham de forma
                            integrada para garantir eficiência e excelência.
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-5">
                        {unidades.map((unidade) => (
                            <div
                                key={unidade.cidade}
                                className="group bg-white/5 border border-white/10 rounded-2xl p-6 hover:bg-red-600 hover:border-red-600 transition-all duration-300"
                            >
                                <div className="w-12 h-12 bg-red-600 group-hover:bg-white/20 rounded-xl flex items-center justify-center mb-6 transition-colors">
                                    <FaMapMarkerAlt />
                                </div>

                                <p className="text-sm text-red-400 group-hover:text-red-100 font-semibold uppercase tracking-wide ">
                                    {unidade.tipo}
                                </p>

                                <h3 className="text-2xl font-bold mt-2 mb-4 text-gray-400">
                                    {unidade.cidade}
                                    <span className="text-gray-400 group-hover:text-red-100 text-base ">
                                        {' '}/ {unidade.estado}
                                    </span>
                                </h3>

                                <p className="text-gray-400 group-hover:text-red-50 text-sm leading-relaxed">
                                    {unidade.descricao}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* NÚMEROS */}
            <section className="py-16 bg-[#D21214] text-white">
                <div className="container mx-auto px-4">

                    <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 text-center">

                        <NumberItem
                            numero="42"
                            descricao="Anos de história"
                        />

                        <NumberItem
                            numero="5"
                            descricao="Unidades"
                        />

                        <NumberItem
                            numero="500+"
                            descricao="Colaboradores"
                        />

                        <NumberItem
                            numero="200+"
                            descricao="Cidades atendidas"
                        />

                    </div>
                </div>
            </section>

            {/* VALORES */}
            <section className="py-20 md:py-28 bg-gray-50">
                <div className="container mx-auto px-4">

                    <div className="text-center max-w-3xl mx-auto mb-16">
                        <span className="text-red-600 font-bold text-sm tracking-widest uppercase">
                            Nossa essência
                        </span>

                        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mt-3 mb-5">
                            Valores que nos direcionam
                        </h2>

                        <p className="text-gray-600 text-lg">
                            Princípios que fazem parte da nossa história e orientam
                            nossas decisões todos os dias.
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
                        {valores.map((valor) => (
                            <div
                                key={valor.titulo}
                                className="bg-white rounded-2xl p-8 border border-gray-100 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
                            >
                                <div className="w-14 h-14 bg-red-50 text-red-600 rounded-2xl flex items-center justify-center text-2xl mb-6">
                                    {valor.icon}
                                </div>

                                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                                    {valor.titulo}
                                </h3>

                                <p className="text-gray-600 leading-relaxed">
                                    {valor.descricao}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* FECHAMENTO */}
            <section className="py-20 md:py-28">
                <div className="container mx-auto px-4">

                    <div className="relative overflow-hidden bg-gray-950 rounded-3xl px-8 py-16 md:p-20 text-center text-white">

                        <div className="absolute top-0 right-0 w-80 h-80 bg-red-600/20 rounded-full blur-3xl" />
                        <div className="absolute bottom-0 left-0 w-80 h-80 bg-yellow-400/10 rounded-full blur-3xl" />

                        <div className="relative z-10 max-w-4xl mx-auto">
                            <span className="text-red-400 font-bold text-sm tracking-widest uppercase">
                                O futuro continua
                            </span>

                            <h2 className="text-3xl md:text-5xl text-white font-bold mt-4 mb-6 leading-tight">
                                42 anos de história.
                                <span className="block text-red-500">
                                    E seguimos em movimento.
                                </span>
                            </h2>

                            <p className="text-gray-300 text-lg md:text-xl leading-relaxed max-w-3xl mx-auto">
                                Seguimos construindo nossa história com a experiência de
                                quem atua há mais de quatro décadas e com a determinação
                                de continuar evoluindo, investindo em pessoas, tecnologia
                                e excelência operacional.
                            </p>

                            <div className="w-20 h-1 bg-red-600 mx-auto my-8 rounded-full" />

                            <p className="text-xl md:text-2xl font-semibold">
                                Distribuidora York
                            </p>

                            <p className="text-gray-400 mt-2">
                                Conectando pessoas, entregando excelência e construindo o futuro.
                            </p>
                        </div>

                    </div>
                </div>
            </section>

        </main>
    );
}


/* COMPONENTES AUXILIARES */

function TimelineItem({ ano, titulo, descricao, lado }) {
    const isLeft = lado === 'left';

    return (
        <div className="relative md:grid md:grid-cols-2 md:gap-16 mb-12 last:mb-0">

            <div
                className={`
                    ${isLeft ? 'md:text-right' : 'md:col-start-2'}
                    bg-white rounded-2xl p-7 shadow-sm border border-gray-100
                `}
            >
                <span className="inline-block text-red-600 font-bold text-sm uppercase tracking-widest mb-2">
                    {ano}
                </span>

                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                    {titulo}
                </h3>

                <p className="text-gray-600 leading-relaxed">
                    {descricao}
                </p>
            </div>

            {/* Ponto central */}
            <div className="hidden md:flex absolute left-1/2 top-8 -translate-x-1/2 w-5 h-5 bg-red-600 border-4 border-white rounded-full shadow-md z-10" />

        </div>
    );
}


function CheckItem({ text }) {
    return (
        <div className="flex items-center gap-3">
            <div className="w-7 h-7 flex-shrink-0 bg-red-600 text-white rounded-full flex items-center justify-center">
                <FaCheckCircle size={12} />
            </div>

            <span className="text-gray-700 font-medium">
                {text}
            </span>
        </div>
    );
}


function NumberItem({ numero, descricao }) {
    return (
        <div>
            <p className="text-4xl md:text-6xl font-bold text-white">
                {numero}
            </p>

            <p className="text-red-100 mt-2">
                {descricao}
            </p>
        </div>
    );
}

export default AboutPage;